import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell.tsx";
import { StudioCopy } from "./components/StudioCopy.tsx";

export function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Shell />}>
					<Route index element={<StudioCopy />} />
					<Route path="*" element={<Navigate to="/" replace />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
